import {notification} from "antd";
import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import PageTitle from "../../components/PageTitle";
import {getCharacterOutfitDetail} from "../../helpers/api/character";
import CharacterOutfitItemTable from "./CharacterOutfitItemTable";

const CharacterOutfitDetail = () => {

    const {characterId, outfitId} = useParams();

    const [outfit, setOutFit] = useState<any>(null);

    const [api, contextHolder] = notification.useNotification();

    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    useEffect(() => {
        if (!characterId || !outfitId) {
            return;
        }
        getOutfitDetailById();
    }, [characterId, outfitId]);

    const getOutfitDetailById = async () => {
        try {
            const res = await getCharacterOutfitDetail(characterId as string, outfitId as string);
            setOutFit(res.data.data);
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
    }

    return (
        outfit && (<>
            {contextHolder}

            <PageTitle
                breadCrumbItems={[
                    {label: "Character", path: "/characters", active: false},
                    {label: "Character detail", path: "/characters/" + characterId, active: false},
                    {label: "Outfit detail", path: "/characters/" + characterId + "/outfits/" + outfitId, active: true},
                ]}
                title={<span><span className="text-danger">{outfit.name}</span></span>}
            />

            <Row>
                <Col>
                    <CharacterOutfitItemTable outfit={outfit}/>
                </Col>
            </Row>
        </>)
    );
};

export default CharacterOutfitDetail;
